import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconCheckCircle, IconError, IconInfo, IconRemoveCircle } from '@travel-frontend/icons';
import { Flex } from '../../../primitives/Flex/index.js';
import { ParagraphMedium, ParagraphMediumBold } from '../../../primitives/Typography/index.js';
export const Message = ({
  message,
  variant = 'info',
  caption
}) => {
  const variantIcon = {
    info: _jsx(IconInfo, {}),
    success: _jsx(IconCheckCircle, {}),
    warning: _jsx(IconError, {}),
    error: _jsx(IconRemoveCircle, {})
  };
  return _jsxs(Flex, {
    direction: "row",
    alignItems: "center",
    children: [variantIcon[variant], _jsxs("div", {
      children: [caption && _jsx(ParagraphMediumBold, {
        color: "contentInversePrimary",
        children: caption
      }), message && _jsx(ParagraphMedium, {
        truncate: true,
        color: "contentInversePrimary",
        paddingRight: "16px",
        children: message
      })]
    })]
  });
};